module.exports = __webpack_public_path__ + "static/media/medium-fees.24bb3a2c.svg";